export const paginationConfig = {
  pageSize: 10,
};
